export default __webpack_public_path__ + "static/media/location-required-icon.458f1dd3.svg";